module.exports = __webpack_public_path__ + "img/kuaik.3b3c74c0.png";